import { escapeHtml } from "../util/escape-html.js";
export class NodeEmptyStateElement extends HTMLElement {
    #heading = "No stages installed";
    #message = "Install a stage app to see it here.";
    #action;
    connectedCallback() {
        this.render();
    }
    set content(value) {
        this.#heading = value.heading;
        this.#message = value.message;
        this.#action = value.action;
        this.render();
    }
    render() {
        this.innerHTML = `
      <section class="node-card node-empty-state">
        <h2 class="node-card-title">${escapeHtml(this.#heading)}</h2>
        <p>${escapeHtml(this.#message)}</p>
      </section>
    `;
        const action = this.#action;
        if (!action)
            return;
        // #1529: append the action button as a CHILD of the card's own <section> (not a
        // sibling of <node-empty-state> in the outlet) so it's visually and structurally
        // grouped with the heading/message, and style it with the skin's real primary-button
        // treatment (`.p2-primary-btn`, also used on the profile stage) rather than the
        // link-styled `.node-nav-link` a prior version of this fallback bolted on — that class
        // was authored for the (retired) rail stage-nav list (transparent background, no
        // border, text-align:left) and reads as bare unstyled text, not an actionable button.
        const button = document.createElement("button");
        button.type = "button";
        button.className = "p2-primary-btn node-empty-state-action";
        button.textContent = action.label;
        button.addEventListener("click", () => action.onClick(), { once: true });
        this.querySelector(".node-empty-state")?.append(button);
    }
}
//# sourceMappingURL=node-empty-state.js.map